const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');

export const resizeImage = (imageFile, maxW, callBack) => {
  const img = new Image();
  img.onload = () => {
    const iw = img.width;
    const ih = img.height;
    // const scale = Math.min((maxW / iw), (maxH / ih));
    const scale = maxW / iw;
    const iwScaled = iw * scale;
    const ihScaled = ih * scale;
    canvas.width = iwScaled;
    canvas.height = ihScaled;
    ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
    // console.log(canvas.toDataURL());
    callBack && callBack(canvas.toDataURL());
    // return canvas.toDataURL();
  };
  img.src = URL.createObjectURL(imageFile);
};
